const localization = {
  en: {
    viewAll: 'View All > ',
    noDataAvailable: 'No Data Available',
    noData: 'No Upcoming Visits',
    somethingWentWrong: 'Something went wrong',
    upcomingVisits: 'Upcoming Visits',
    checkin: 'Time to Check In',
    startedCheckin: 'Continue Check-In',
    completedCheckin: 'Check In Completed'
  },
  es: {
    viewAll: 'Ver todo > ',
    noDataAvailable: 'No hay datos disponibles',
    noData: 'No tiene citas futuras',
    somethingWentWrong: 'Ha ocurrido un error',
    upcomingVisits: 'Citas futuras',
    checkin: 'Hora de registrarse',
    startedCheckin: 'Continuar con el registro',
    completedCheckin: 'Registro completado'
  },
  keyMapping: {
    viewAll: 'UFD_View_All',
    noData: 'UFD_No_Upcoming_Visit',
    somethingWentWrong: 'UFD_Error_Text',
    upcomingVisits: 'UFD_Upcoming_Visits_Text',
    checkin: 'UFD_Time_To_Check_In',
    completedCheckin: 'UFD_Check_In_Completed',
    noDataAvailable: 'UFD_No_Data_Text',
    startedCheckin: 'UFD_Continue_Check_In'
  }
}

export default localization
